import { APP_SETTINGS } from "../../config";
import axios from "axios";

export function createQaProtocol(data) {
  var response = axios.post(
    APP_SETTINGS.API_PATH.QA_PROTOCOL.createQaProtocol,
    data
  );
  return response;
}

export function editQaProtocol(data) {
  var response = axios.patch(
    APP_SETTINGS.API_PATH.QA_PROTOCOL.editQaProtocol,
    data
  );
  return response;
}

export function getAllQaProtocol(data) {
  var url = `${
    APP_SETTINGS.API_PATH.QA_PROTOCOL.getAllQaProtocol
  }?page=${1}&limit=${1000}`;
  var response = axios.post(url, data);
  return response;
}

export function deleteProtocol(id) {
  var url = `${APP_SETTINGS.API_PATH.QA_PROTOCOL.deleteProtocol}?id=${id}`;
  var response = axios.delete(url);
  return response;
}

export function qaProtocolReport(data) {
  var response = axios.post(
    APP_SETTINGS.API_PATH.QA_PROTOCOL.qaProtocolReport,
    data
  );
  return response;
}
